import React from "react";
import Footer from "../layouts/Footer";
import PageWrapper from "../layouts/PageWrapper";

const Page404 = () => {
  return (
    <PageWrapper>
      <div className="page">
        <div className="page404">
          <div>
          <h1 class="errorCode">404</h1>
          <p class="errorMessage">Page Not Found</p>
          </div>
        </div>
      </div>
      <Footer />
    </PageWrapper>
  );
};

export default Page404;
